import React from 'react';
import HallOfFame from 'models/battles/HallOfFame';
import images from 'assets/images';
import { Tile } from '../Tile';
import { FormattedMessage } from 'react-intl';

export type MarathonTileProps = {
	data: HallOfFame;
};

export const MarathonTile = ({ data }: MarathonTileProps) => {
	const currentData = data.players.marathonRuner;

	if (!currentData) {
		return null;
	}

	return (
		<Tile
			title={<FormattedMessage id={`battle-hof.type.marathon.title`} />}
			dateFrom={data.dateFrom}
			dateTo={data.dateTo}
			playerAvatar={currentData.avatar}
			playerName={currentData.fullname}
			icon={images.battles.battlesMarathon}
			text={<FormattedMessage id={`battle-hof.type.marathon.text`} values={{ value: currentData.battleCount }} />}
		/>
	);
};
